module.exports = __webpack_public_path__ + "img/00005.1fd9be1a.webp";